export const ERROR = "ProductsSlice/error";
export const Loading = "ProductsSlice/loading";
export const PRODUCTSVIEWED  = "ProductsSlice/viewed";
export const PRODUCTSCREATED = "ProductsSlice/created";
export const PRODUCTSUPDATED = "ProductsSlice/updated";
export const PRODUCTSDELETED = "ProductsSlice/deleted";
export const FEATUREDPRODUCT = "ProductsSlice/featured";